import styled, { css } from 'styled-components';
import { breakpoint } from '../theme/breakpoint';
import { UnorderedList } from '../styled/typography';

export const Wrapper = styled.div`
  ${breakpoint.desktop`
    max-width: 260px;
  `};
`;

export const TimeList = styled(UnorderedList)`
  list-style: none;
  padding: 0;
`;

export const Time = styled.li`
  display: flex;
  font-weight: ${({ $today, theme }) => $today && theme.fontWeight.bold};
  margin-left: -${({ theme }) => theme.spacing.small};
  padding-left: ${({ theme }) => theme.spacing.small};
  border-left: none;
  ${({ $today }) =>
    $today &&
    css`
      border-left: ${({ theme }) => `2px solid ${theme.palette.brand}`};
    `}
  color: ${({ theme, $closed }) => $closed && theme.palette.secondaryText};
`;

export const Day = styled.div`
  flex: 1;
`;

export const TimeVal = styled.div`
  text-align: right;
  ${breakpoint.mobileLand`
    flex: 4;
  `};
`;
